import { GetEvent } from "../controllers/company/EventsController";
import { url } from "./apiBase";


const dashboardUrl = url + 'dashboard/';

const CompanyRoutes = {
    Ciudades:
    {
        GetAll: url + 'configuracion/ciudades/all',
    },
    Regions:{
        GetRegionAndCities: url + 'public/locations/regions/',//completar con el pais
    },
    Profile:
    {
        GetDatos : url + 'perfil/shop/datos',
        GetImagenes : url + 'perfil/shop/imagenes',
        UpdatePicture: url + 'perfil/shop/imagenes/update',
        UpdateDatosEmpresa: url + 'perfil/shop/datos/update',
        UpdateDatosContacto: url + 'perfil/shop/contactos/update',
        UpdateCoordenadas: url + 'perfil/shop/coordenadas/update',

        GetRedesSociales: url + 'perfil/shop/redesSociales/get',
        AddRedSocial: url + 'perfil/shop/redesSociales/add',
        UpdateRedSocial: url + 'perfil/shop/redesSociales/update',

        GetHorarios: url + 'perfil/shop/horarios/get',
        AddHorario: url + 'perfil/shop/horarios/add',
        UpdateHorario: url + 'perfil/shop/horarios/update',
    },
    Schedules:{
        GetAll: (type,id) => url + `dashboard/schedules?type=${type}&id=${id}`,
        Save: url + `dashboard/schedules`
    },
    Employees:{
        getAll: url + 'dashboard/employees',
        create: url + 'dashboard/employees',
        show:   (id) => url + `dashboard/employees/${id}`,
        update: (id) => url + `dashboard/employees/${id}`,
        delete: (id) => url + `dashboard/employees/${id}`
    },
    Products:
    {
        Attributes:
        {
            getAll: url + 'dashboard/products/attributes',
            create: url + 'dashboard/products/attributes',
            delete: url + 'dashboard/products/attributes/', //completar con el ID del atributo
            Values:
            {
                getAll: url + 'dashboard/products/attributes/', //completar con /:attributeId/attribute-values
                create: url + 'dashboard/products/attributes/', //completar con /:attributeId/attribute-values
                show: url + 'dashboard/products/attributes/attribute-values/', //completar con /:attributeValueId
                update: url + 'dashboard/products/attributes/attribute-values/', //completar con /:attributeValueId
                delete: url + 'dashboard/products/attributes/attribute-values/', //completar con /:attributeValueId
            }
        },
        ModifierGroups:
        {
            getAll: url + 'dashboard/products/modifier-groups',
            create: url + 'dashboard/products/modifier-groups',
            show: url + 'dashboard/products/modifier-groups/', //completar con /:modifierGroupId
            update: url + 'dashboard/products/modifier-groups/', //completar con /:modifierGroupId
            delete: url + 'dashboard/products/modifier-groups/', //completar con /:modifierGroupId
            ModifierOptions:
            {
                getAll: url + 'dashboard/products/modifier-groups/', //completar con /:modifierGroupId/modifier-options
                create: (modifierGroupId) => url + `dashboard/products/modifier-groups/${modifierGroupId}/modifiers`, //completar con /:modifierGroupId/modifier-options
                show: (modifierId) => url + `dashboard/products/modifiers/${modifierId}`, //completar con /:modifierOptionId
                update: (modifierId) => url + `dashboard/products/modifiers/${modifierId}`, //completar con /:modifierOptionId
                delete: (modifierId) => url + `dashboard/products/modifiers/${modifierId}`, //completar con /:modifierOptionId
            }
        },
        getAll: url + 'dashboard/products/products',
        getForStoreData: url + 'dashboard/products/for-store-data',
        create: url + 'dashboard/products/products',
        show: url + 'dashboard/products/products',//completar con el di del producto
        update: url + 'dashboard/products/products',
        GetProducts: url + 'productos/negocio/',//completar con el uuid del comercio
        ChangeStatus: url + 'productos/changestatus',
        GetForAdd: url + 'productos/forAdd',
        Add: url + 'productos/add',
        Update: url + 'productos/update'
    },
    Subscriptions:
    {
        Plans:{
            getAll: url + 'dashboard/subscriptions/plans',
            create: url + 'dashboard/subscriptions/plans',
            show: (id) => url + `dashboard/subscriptions/plans/${id}`,
            update: (id) => url + `dashboard/subscriptions/plans/${id}`,
            delete: (id) => url + `dashboard/subscriptions/plans/${id}`
            //update: url + 'dashboard/subscriptions/plans',
        },
        Subscriptions:{
            getAll: url + 'dashboard/subscriptions/subscriptions',
            create: url + 'dashboard/subscriptions/subscriptions',
            cancel: (id) => url + `dashboard/subscriptions/${id}/cancel`,
            statistics: () => url + `dashboard/subscriptions/statistics`
        }
    },
    Bookings:{
        GetStats: url + `dashboard/bookings/stats`,
        CalendarResource: url + `dashboard/bookings/resources`,
        CalendarEvents: (startStr,endStr) => url + `dashboard/bookings/calendar?start=${startStr}&end=${endStr}`,
        Update: (uuid) => url + `dashboard/bookings/${uuid}/update`,
        UpdateStatus: (uuid) => url + `dashboard/bookings/${uuid}/status`,
        GetFormOptions: url + `dashboard/bookings/form-options`,
        CheckAvailability: url + `dashboard/bookings/check-availability`,
        Create: url + `dashboard/bookings/create`
    },
    Assets: {
        getAll: url + `dashboard/assets`,
        create: url + `dashboard/assets`,
        update: (id) => url + `dashboard/assets/${id}`,
        delete: (id) => url + `dashboard/assets/${id}`,
    },
    ProductResources: {
        // GET: Ver recursos de un producto
        getByProduct: (productId) => url + `dashboard/products/products/${productId}/resources`,
        // POST: Asignar recurso
        assign: url + `dashboard/products/resources`,
        // DELETE: Desvincular recurso
        remove: (id) => url + `dashboard/products/resources/${id}`,
    },
    CRM:
    {
        Customers:{
            create: url + `dashboard/crm/customers`,
            search: (query) => url + `dashboard/crm/customers/search?q=${query}`
        }
    },
    SubCategories: 
    {
        GetAll: url + 'subcategorias/all',
        ChangeStatus: url + 'subcategorias/changestatus',
        Add: url + 'subcategorias/add',
        Update: url + 'subcategorias/update'
    },
    Coupons:
    {
        GetAllFromMerchant: url + 'coupons/allFromMerchant',
        Add: url + 'coupons/add',
    },
    Associates:
    {
        GetAll: url + 'associates/all',
        GetByUUID: url + 'public/associates/byuuid/', //completar con uuid
        Add: url + 'associates/add',
        Update: url + 'associates/update'
    },
    Events:
    {
        GetAll: (status) => dashboardUrl + `events/status/${status}`, //completar con el status del evento
        GetEventStats: (eventId) => dashboardUrl + `events/stats/${eventId}`,
        GetEvent: (eventId) => dashboardUrl + `events/event/${eventId}`,
        GetEventSections: (eventId) => dashboardUrl + `events/sections/event/${eventId}`,
        Show: (eventId) => dashboardUrl + `events/event/${eventId}`,
        ToStore: url + 'eventos/tostore',
        Add: url + 'eventos/create',
        //Show: url + 'eventos/show/', //completar con el ID del evento
        Update: url + 'eventos/update/', // completar 
        ChangeStatus: url + 'eventos/destroy/', //completar con el ID del evento
        Categories:
        {
            All: url + 'eventos/categorias'
        },
        Sections:
        {
            GetEventSections: (eventId) => dashboardUrl + `events/sections/event/${eventId}`,
            ToggleStatus: (uuid) => dashboardUrl + `events/sections/toggle_status/${uuid}`,
            Create: dashboardUrl + `events/sections/create` ,//url + 'eventos/secciones/create',
            Update: (uuid) => dashboardUrl + `events/sections/update/${uuid}`, //completar con el UUID de la seccion
            List: url + 'eventos/secciones/', //completar con el ID del evento
            ChangeStatus: url + 'eventos/secciones/destroy/', //completar con el UUID de la seccion
            
        },
        Tickets:
        {
            BoxOfficeIssue: dashboardUrl + `events/tickets/box_office/issue`,
            GetEventTickets: (eventId) => dashboardUrl + `events/tickets/event/${eventId}`,
            Validate: (ticketId) => dashboardUrl + `events/tickets/validate/${ticketId}`,
            Annul: (ticketId) => dashboardUrl + `events/tickets/annul/${ticketId}`,
            ResendEmail: (ticketId) => dashboardUrl + `events/tickets/resend-email/${ticketId}`,
            GetImages: url + 'eventos/boleto/', //completar con ID del evento
            Create: url + 'eventos/boleto/create', //sin parametro para crear, para actualizar mandar el uuid del registro
            Issue: url + 'merchant/pedido/boleto',
            SoldByEvent: url + 'merchant/pedido/boletos/vendidos/', //completar con evento_id
            SoldByEventPublic: url + 'public/boletos/vendidos/', //completar con evento_id
            Destroy: url + 'eventos/tickets/destroy/', //completar con {uuid}/{status}
        },
        Sponsors:
        {
            GetAllByEvent: url + 'eventos/patrocinadores/', //completar com {evento_id}
            Create: url + 'eventos/patrocinadores/create',
        },
        Gastromedia:
        {
            GetCompetitor: url + 'eventos/gastromedia/', //completar con el id del evento
        },
        Products:
        {
            GetProducts: url + 'comercios/evento/', //completar con evento_id
            SetProductEvent: url + 'comercios/evento/store',
        }
    },
    Finances:
    {
        BankAccounts:
        {
            GetToCrerate: url + 'finanzas/nrocuentas/create',
            Add: url + 'finanzas/nrocuentas/create',
            //GetAll: url + 'finanzas/nrocuentas',
            ChangeStatus: url + 'finanzas/nrocuentas/destroy/', //completar con el ID
            Delete: url + 'finanzas/nrocuentas/delete/', //completar con el ID,
            GetAll: url + 'dashboard/account_numbers', //GET
            Store: url + 'dashboard/account_numbers',
            paymentOptions: url + 'dashboard/paymentoptions',
        }
    },
    Apps:
    {
        GetAppUser : url + 'apps/getAppUser/', //completar con el ID de la app
    },
    Tourism:
    {
        GetToAdd: url + 'tourism/ally/to_add',
        Add: url + 'tourism/ally/add',
        GetAll: url + 'tourism/ally/all',
        GetPlace: url + 'tourism/ally/place/', // completar con el uuid
        Update: url + 'tourism/ally/place/', // completar con el uuid
        ChangeStatus: url + 'tourism/ally/changestatus/', // completar con el uuid
    },
    Reservations:
    {
        GetToBeApproved: url + 'comercios/reservations',
        Approve: url + 'comercios/reservations/approve',
        Approved: url + 'comercios/reservations/approved',
        historical: url + 'comercios/reservations/historical',
    },
    Reviews:
    {
        GetAll: url + 'merchant/reviews'
    },
    Orders:
    {
        GetOrderPaymentDestinations: dashboardUrl + 'order_payment_destinations',
        InsertManualPayment: (orderId) => `${dashboardUrl}orders/${orderId}/manual_payment`,
        GetOrders: url + 'pedidos/comercio/orders',
        GetOrdersDetails: (orderId) => dashboardUrl + `orders/${orderId}`,//url + 'pedidos/comercio/orders/details/', //completar con el codigo del pedido
        UpdateOrderStatus : url + 'pedidos/comercio/orderstatus',
    },
    Analitycs:{
        Views: url + 'analytics/views/', //complete with type
    },
    Entities:{
        SearchEntities: url + 'entities/find'
    },
    Cashless:{
        Economies:{
            GetAll: url + 'cashless/merchant/economies',
            Create: url + 'cashless/merchant/economies/create',
            GetByUUID: url + 'cashless/merchant/economies/byuuid/', //completar con el UUID
        },
        Participants:{
            GetAll: url + 'cashless/merchant/participants/economy/', //Completar con el UUID de la economia
            Create: url + 'cashless/merchant/participants/create',
            
        },
        Pos:{
            GetAll: url + 'cashless/merchant/pos/economy/', //Completar con el ID de la economia
            Create: url + 'cashless/merchant/pos/create',
        },
        Transactions:{
            GetAll: url + 'cashless/transactions/economy/', //completar con el ID de la economia
        }
    }
    /**
     * CompanySignup : url + 'companysignup',
     */
};


export default CompanyRoutes;